import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, formatApiError } from "@/lib/api";
import { BatchFullDialog, isBatchFull } from "@/components/attendance/BatchFullDialog";

export default function MoveCandidateDialog({ candidate, batches, isAdmin, onClose, onMoved }) {
  const [dest, setDest] = useState("");
  const [busy, setBusy] = useState(false);
  const [full, setFull] = useState(null);
  if (!candidate) return null;
  const options = batches.filter((b) => b.id !== candidate.batch_id && b.status !== "ARCHIVED" && (isAdmin || b.center_id === candidate.center_id));
  const destBatch = options.find((b) => b.id === dest);
  const move = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/attendance/candidates/${candidate.id}/move`, { batch_id: dest }); toast.success(data.message); onMoved(); onClose(); }
    catch (e) { if (isBatchFull(e)) setFull(e.response.data.detail); else toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <BatchFullDialog info={full} onClose={() => { setFull(null); setDest(""); }} />
      <DialogContent data-testid="move-dialog" className="max-w-md">
        <DialogHeader><DialogTitle className="font-display">Move Candidate</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-700"><b>{candidate.name}</b> · Current batch: <b>{candidate.batch_name || "—"}</b></p>
        <Select value={dest} onValueChange={setDest}><SelectTrigger data-testid="move-dest"><SelectValue placeholder="Move to batch…" /></SelectTrigger>
          <SelectContent>{options.map((b) => <SelectItem key={b.id} value={b.id} disabled={b.is_full}>{b.name}{b.capacity != null ? ` (${b.candidate_count}/${b.capacity}${b.is_full ? " — Full" : ""})` : ""}{isAdmin && b.center_id !== candidate.center_id ? " (other center)" : ""}</SelectItem>)}</SelectContent></Select>
        {destBatch && <p className="text-sm text-slate-600" data-testid="move-confirm-text">Move {candidate.name} from {candidate.batch_name || "no batch"} to {destBatch.name}?</p>}
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} className="rounded-xl">Cancel</Button>
          <Button data-testid="move-submit" disabled={!dest || busy} onClick={move} className="rounded-xl bg-emerald-700 hover:bg-emerald-800 text-white">{busy ? "Moving…" : "Move Candidate"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
